import type React from "react";
import {useCallback} from "react";
import {useNavigate, useParams} from "react-router-dom";

import {faArrowRight} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

import {usePlaylist} from "~/api/hooks/usePlaylist";
import CustomButton from "~/component/common/CustomButton";

import type {PlayLevelParams} from "../PlayLevelParams";

const NextButton: React.FC = () => {
  const {id, playlistId} = useParams<PlayLevelParams>();
  const {data: playlistData} = usePlaylist({id: playlistId});
  const navigate = useNavigate();

  const handleNext = useCallback(() => {
    if (playlistData && id) {
      const index = playlistData.levelIds.indexOf(id);
      if (index < playlistData.levelIds.length - 1) {
        const nextLevelId = playlistData.levelIds[index + 1];
        navigate(`/playlist/${playlistId}/play/${nextLevelId}`);
      }
    }
  }, [id, navigate, playlistData, playlistId]);

  return (
    <CustomButton
      onClick={handleNext}
      aria-label="Next"
      className="w-10 h-10 bg-blue-500 hover:bg-blue-600 disabled:bg-gray-600 text-white disabled:text-gray-300 rounded-lg transition-colors flex items-center justify-center"
      disabled={
        playlistData?.levelIds.indexOf(id!) ===
        (playlistData?.levelIds.length ?? 1) - 1
      }
    >
      <FontAwesomeIcon icon={faArrowRight} size="xl" />
    </CustomButton>
  );
};

export default NextButton;
